import React from 'react';
import { motion } from 'framer-motion';
const faqs = [{
  q: 'Is it too late to see results this year?',
  a: "Absolutely not. Recalibrating now gives you an unfair advantage. While others are slowing down, you'll be accelerating into the end of the year."
}, {
  q: 'How is the product delivered?',
  a: 'You will get instant access to the digital PDF guides immediately after purchase. You can start your reboot in the next 5 minutes.'
}, {
  q: 'How quickly will I see results?',
  a: 'Most users report a significant shift in mental clarity and focus within the first 48 to 72 hours of implementing the baseline protocols.'
}];
export function FAQ() {
  return <section className="py-24 px-4 bg-zinc-900/30 border-y border-white/5" data-id="element-44" data-mp="1v5hl2jhkodt1">
      <div className="max-w-3xl mx-auto" data-id="element-45" data-mp="oow1770qnaxk">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-46" data-mp="opypd76oez9s">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4" data-id="element-47" data-mp="johrlkjhnsxf">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-zinc-900/80 border border-white/5 p-6 md:p-8 rounded-2xl" data-id="element-48" data-mp="1kp1mhhueyptj" data-mpi={index}>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-49" data-mp="16p0ku06bred0">
                {faq.q}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-50" data-mp="s0m90zqxkfkb">{faq.a}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}